/**
 * @desc 查看环保监测列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EPMonitorRequest,
): Promise<
  defs.StandardReturn<Array<defs.EnvironmentalMonitoringListResponse>>
> {
  return defHttp.post({
    url: '/wap/monitoring/queryMonitorList',
    data,
  });
}

export function mock(
  data: defs.EPMonitorRequest,
): Promise<
  defs.StandardReturn<Array<defs.EnvironmentalMonitoringListResponse>>
> {
  return defHttp.post({
    url: '/mock/wap/monitoring/queryMonitorList',
    data,
  });
}
